import { store } from "@irati/store";
import AuthStream from "../streams/auth";
import UnauthedStream from "../streams/unauthed";
import AuthActions from "./actions/AuthActions";
var SyncToRedux = /** @class */ (function () {
    function SyncToRedux() {
        var _this = this;
        this.authedListener = null;
        this.unauthedListener = null;
        this.authData = null;
        this.unauthedData = null;
        // Due to circular refs, we need to delay this to next JS tick using setTimeout
        setTimeout(function () {
            if (!_this.authedListener) {
                _this.authedListener = _this.listenToAuth(AuthStream, function (auth) {
                    if (auth && auth.user) {
                        _this.authData = {
                            apps: auth.productPermissions,
                            branding: auth.branding,
                            onboarding: auth.userOnboarding,
                            sessionId: auth.sessionId,
                            upsell: auth.upsell,
                            user: auth.user,
                            userTenant: auth.userTenant
                        };
                    }
                    else {
                        _this.authData = null;
                    }
                    _this.next();
                });
            }
            if (!_this.unauthedListener) {
                _this.unauthedListener = _this.listenToAuth(UnauthedStream, function (auth) {
                    _this.unauthedData = {
                        branding: auth.branding,
                        unauthedBusiness: auth.unauthedBusiness,
                        userTenant: auth.userTenant
                    };
                    _this.next();
                });
            }
        });
    }
    SyncToRedux.prototype.next = function () {
        if (this.authData) {
            store.dispatch(AuthActions.SyncFromV4(this.authData));
        }
        else if (this.unauthedData) {
            store.dispatch(AuthActions.SyncFromV4(this.unauthedData));
        }
    };
    SyncToRedux.prototype.listenToAuth = function (service, update) {
        var _this = this;
        return service.subscribe(function (auth) {
            update(auth);
        }, undefined, function () {
            update(null);
            _this.authedListener = _this.listenToAuth(service, update);
        });
    };
    return SyncToRedux;
}());
export default new SyncToRedux();
